<template>
  <div id="hres83e-detail" class="hres83e-detail hrms-searchbox-table clearfix">
    <div :class="[searchboxDisp == true ? 'search-group-wrapper' : 'search-group-wrapper-min']">
      <div ref="searchboxPanel" class="search-box-panel clearfix" v-show="searchboxDisp">

        <div class="asset-title">
          <!-- <div class="assetno">{{ indexSelected.assetno }}</div> -->
          <div class="desc_assetno">{{ indexSelected.desc_assetno }}</div>
        </div>
        <!-- <template v-if="indexSelected.namimagepath !== ''">
          <img :src="indexSelected.namimagepath" style="width: 100%">
        </template>
        <template v-else>
          <img src="../../assets/img/no-image-landscape.png" style="width: 100%">
        </template> -->
        <calendar :calendar="calendar"
                  :setDateSelected="setDateSelected"
                  :days="label.days[app.nowLang]"
                  :month="label.month[app.nowLang]"
                  :defaultDate="defaultDate"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  :toggle="toggle" />
      </div>
    </div>

    <div ref="table" class="clearfix" :class="[searchboxDisp == true ? 'table-box-wrapper' : 'table-box-wrapper-full']">
      <div v-show="calendarDetailDisp">
        <div class="box-header with-border">
          <h3 class="box-title">
            <i class="fa fa-file-text margin-r-5"></i>
            {{ labels['HREP83EC3']['40'] }} {{ setDateOutput(dateSelected) }}
          </h3>
        </div>
        <hrms-table :columns="detailColumns"
                    :data="calendarDetail"
                    :nowLang="nowLang"
                    :addEvent="addEvent"
                    :addBtnDisp="presentConFlg"
                    :editEvent="editEvent"
                    :cancelEvent="cancelEvent"
                    :rowDisableCondition="rowDisableCondition" />
        <div class="col-xs-12">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
        </div>
      </div>

      <reserve v-show="reserveDisp"
              :eventDetail="eventDetail"
              :labels="labels"
              :toggle="toggle"
              :nowLang="nowLang"
              :labelsButton="labelsButton"
              :descCodapp="descCodapp"
              :dateSelected="dateSelected"
              :indexSelected="indexSelected"
              :calendarSelected="calendarSelected"
              :searchIndex="searchIndex"
              :detail="reserveDetail"
              :currentUser="codempid"
              :reserveYear="reserveYear"
              :reserveMonth="reserveMonth"
              :postHres83eReserveSave="postHres83eReserveSave" />
    </div>
  </div>
</template>

<script>
import calendar from 'components/hres83e/calendar'
import reserve from 'components/hres83e/reserve'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres83e-detail',
  props: [ 'calendarDetailDisp', 'reserveDisp', 'labels', 'labelsButton', 'toggle', 'nowLang', 'detailColumns', 'indexSelected', 'calendarSelected', 'dateSelected', 'setDateSelected', 'reserveDay', 'reserveDate', 'reserveMonth', 'reserveYear', 'searchIndex', 'calendar', 'calendarDetail', 'receivedHres83eCalendar', 'receivedHres83eReserveCreate', 'receivedHres83eReserveDetail', 'setCalendarSelected', 'postHres83eReserveCancel', 'descCodapp', 'reserveDetail', 'postHres83eReserveSave' ],
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent,
      label: require('src/../config/label'),
      loadingParentBool: true,
      searchboxDisp: true,
      eventDetail: '',
      defaultDate: {
        currentYear: this.reserveYear,
        currentMonth: this.reserveMonth,
        currentDate: this.reserveDate,
        currentDay: this.reserveDay
      },
      presentConFlg: true
    }
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    }
  },
  watch: {
    reserveYear () {
      this.setDefaultDate()
    },
    reserveMonth () {
      this.setDefaultDate()
    },
    reserveDate () {
      this.setDefaultDate()
    },
    dateSelected () {
      let arrDateSelected = this.dateSelected.split('/')
      let d1 = new Date()
      let d2 = new Date(arrDateSelected[1] + '/' + arrDateSelected[0] + '/' + arrDateSelected[2])
      d1.setHours(0, 0, 0, 0)

      if (d1 > d2) {
        this.presentConFlg = false
      } else {
        this.presentConFlg = true
      }
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setDefaultDate () {
      this.defaultDate = {
        currentYear: this.reserveYear,
        currentMonth: this.reserveMonth,
        currentDate: this.reserveDate,
        currentDay: this.reserveDay
      }
    },
    pageDetail (event, param) {
      this.eventDetail = event
      switch (event) {
        case 'add':
          let searchParams = {
            assetno: this.indexSelected.assetno,
            dtereserv: this.dateSelected
          }
          this.receivedHres83eReserveCreate(searchParams)
          this.toggle('reserve')
          break
        case 'edit':
          if (param.seqno) {
            if (this.indexSelected.staappr === 'C') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            let searchParams = {
              assetno: this.indexSelected.assetno,
              dtereserv: this.dateSelected,
              seqno: param.seqno
            }
            this.receivedHres83eReserveDetail(searchParams)
            this.toggle('reserve')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setCalendarSelected(param)
      this.pageDetail('edit', param)
    },
    cancelEvent (param) {
      this.setCalendarSelected(param)
      if (this.calendarSelected.seqno) {
        let sendParams = {
          assetno: this.indexSelected.assetno,
          dtereserv: this.dateSelected,
          seqno: param.seqno,
          dtemonth: this.reserveMonth,
          dteyear: this.reserveYear
        }
        this.postHres83eReserveCancel({ cancelParams: sendParams, searchParams: this.searchIndex })
      }
    },
    rowDisableCondition (dataRow) {
      return false
    }
  },
  components: {
    calendar,
    reserve
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?6da67dd2